// ── Brand ─────────────────────────────────────────────────────────────────────
export const APP_NAME     = 'RADTAR SkillAssess'
export const APP_SUBTITLE = 'SkillAssess'

// ── Theme ─────────────────────────────────────────────────────────────────────
export const THEME_STORAGE_KEY = 'radtar-theme'
export const DEFAULT_THEME     = 'dark'

// ── Auth ──────────────────────────────────────────────────────────────────────
export const AUTH_SESSION_KEY = 'radtar-session'
export const AUTH_USERS_KEY   = 'radtar-users'

// ── Exam stages ───────────────────────────────────────────────────────────────
export const EXAM_STAGES = {
  SETUP:    'setup',
  BUILDING: 'bank_building',
  PRACTICE: 'in_progress_practice',
  VIRTUAL:  'in_progress_virtual',
  GRADING:  'grading',
  RESULTS:  'results',
}

// ── Difficulty levels ─────────────────────────────────────────────────────────
export const DIFFICULTIES = [
  { key: 'Beginner',     icon: '🌱', color: '#4ade80', label: 'Beginner',     sub: 'Core concepts'      },
  { key: 'Intermediate', icon: '📚', color: '#38bdf8', label: 'Intermediate', sub: 'Applied scenarios'  },
  { key: 'Advanced',     icon: '🔥', color: '#fbbf24', label: 'Advanced',     sub: 'Complex reasoning'  },
  { key: 'Expert',       icon: '⚡', color: '#f87171', label: 'Expert',       sub: 'No hints'           },
]

// ── Question types ────────────────────────────────────────────────────────────
export const QUESTION_TYPES = [
  { key: 'mcq',          icon: '📋', label: 'Multiple Choice',   sub: 'Single best answer',    min: 0, max: 100 },
  { key: 'msq',          icon: '☑️', label: 'Multiple Selection', sub: 'Can select multiple options', min: 0, max: 50  },
  { key: 'true_false',   icon: '✅', label: 'True / False',      sub: 'Binary judgment',       min: 0, max: 50  },
  { key: 'short_answer', icon: '📝', label: 'Descriptive',       sub: 'Written explanation',   min: 0, max: 30  },
]

// ── Exam modes ────────────────────────────────────────────────────────────────
export const EXAM_MODES = [
  { key: 'practice', icon: '📖', label: 'Practice',     sub: 'Instant feedback per question'  },
  { key: 'virtual',  icon: '⏱',  label: 'Virtual Exam', sub: 'Timed · no hints during exam'   },
]

// ── Default question counts ───────────────────────────────────────────────────
// Zero, not a prefilled guess — nothing's been chosen yet until an exam code
// is entered or an exam is picked, at which point its own configured counts
// (or a fresh selection) take over anyway.
export const DEFAULT_QUESTION_COUNTS = { mcq: 0, msq: 0, true_false: 0, short_answer: 0 }

// ── Grading rules ─────────────────────────────────────────────────────────────
export const GRADING = {
  PASS_CUTOFF_PCT:              50,
  SHORT_ANSWER_PARTIAL_WORDS:   5,   // fewer words → Incorrect
  SHORT_ANSWER_CORRECT_WORDS:   15,  // >= words → Correct, else Partially Correct
  PARTIAL_CREDIT:               0.5,
}

// ── Grade display config ──────────────────────────────────────────────────────
export const GRADE_CONFIG = {
  'Excellent':                { color: '#4ade80', emoji: '🏆' },
  'Good':                     { color: '#38bdf8', emoji: '👍' },
  'Needs Work':               { color: '#fbbf24', emoji: '📘' },
  'Needs Significant Review': { color: '#f87171', emoji: '📚' },
}

// ── Timing ────────────────────────────────────────────────────────────────────
export const BANK_BUILD_INTERVAL_MS = 380
export const EXAM_START_DELAY_MS    = 600
export const READINESS_DELAY_MS     = 200
